var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal",class:{ visible: _vm.visible }},[_c('button',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{staticClass:"close-icon"},[_vm._v("+")])]),_c('div',{ref:"modalContent",staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }